<!-- エラー画面説明 -->
<template>
  <div class="crpg-a-error">
    <div class="crpg-a-error__title">{{ $t(`error.title`) }}</div>
    <div class="crpg-a-error__description">
      {{ $t(`error.description`) }}
    </div>
    <i18n path="error.toTop" tag="span" class="crpg-a-error__to-top">
      <template v-slot:link>
        <router-link :to="{ name: 'top' }">{{ $t("error.link") }}</router-link>
      </template>
    </i18n>
  </div>
</template>

<script>
export default {
  name: "AtomsError",
};
</script>

<style lang="scss" scoped>
@import "@/assets/css/atoms/error/error.scss";
</style>
